import React, { Fragment, useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import LeftDrawer from "./LeftDrawer";
import ProfileMenu from "./ProfileMenu";
import MobileMenu from "./MobileMenu";
import Header from "./Header";
import { useHistory } from "react-router";
import {
  CHECKIN,
  COACHING,
  COMPANY,
  DEPARTMENTS,
  EXECUTIVE,
  // ONBOARDING,
  PERFORMANCE_REVIEW,
  PROFILE,
  REPORTS,
  SUCCESS_STORIES,
  TARGET,
  USER_PROFILE,
  VISION,
} from "../../constants/routeConstants";
import { get } from "lodash";
import { Auth } from "aws-amplify";
// import { useLazyQuery, useMutation } from "@apollo/client";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { metaData } from "../../graphQL/queries/profile";
import {
  CompanyState,
  loggedInUserState,
  metaDataState,
} from "../../recoil/LoggedInUserDetail/atom";
import { LEFT_DRAW_INDEX } from "../../constants";
// import { listCountries } from "../../graphQL/queries/metaData";
import { menuDrawerState } from "Recoil/General/atom";
import {
  // setCountries,
  setInstructions,
  setOptionsForCompanySetting,
  setOptionsForReviewCycle,
} from "../../recoil/CompanySetup/selector";
// import { logOutUser } from "../../graphQL/mutation/visionBoardMutations";
import {
  metaDataDetails,
  targetCompletionAnimation,
} from "../../recoil/LoggedInUserDetail/selector";
import { getUserId } from "../../utils";
// import { GETUSER_COMPANY } from "../../constants/literalConstant";
import TargetCompletion from "Components/confettiAnimation/TargetCompletion";
import { useLayout } from "Hooks/layout/useLayout";

const Layout = (props) => {
  const [isDrawerOpen, setDrawerOpen] = useRecoilState(menuDrawerState);
  const [refreshHeader, setRefreshHeader] = useState(true);
  // const breakpoint = 620;
  const menuId = "primary-search-account-menu";
  const mobileMenuId = "primary-search-account-menu-mobile";
  const history = useHistory();
  // const [userDetails, setUserDetails] = useState();
  const [userDetails, setUserDetails] = useState();
  const userId = getUserId();
  // const addCountries = useSetRecoilState(setCountries);
  // const [logOutUserDetail, { loading: logOutLoading }] =
  //   useMutation(logOutUser);
  const addOptionsForCompanySetting = useSetRecoilState(
    setOptionsForCompanySetting
  );
  const addOptionsForReviewCycle = useSetRecoilState(setOptionsForReviewCycle);
  const [showAnimation, setShowAnimation] = useRecoilState(
    targetCompletionAnimation
  );

  const getLoggedInUserState = useRecoilValue(loggedInUserState);
  const getCompanyDetails = useRecoilValue(CompanyState);
  const getMetaDataDetails = useRecoilValue(metaDataState);
  const _setInstructions = useSetRecoilState(setInstructions);

  const {
    getUserDetail,
    getUserCompany,
    metaDataDetailValues,
    getCountriesList,
    logOutUserDetail,
    logOutLoading,
  } = useLayout();
  // const [getUserDetail] = useLazyQuery(getLoggedInUser, {
  //   ssr: false,
  //   nextFetchPolicy: FETCH_POLICY.cacheOnly,
  //   onCompleted: (data) => {
  //     setLoggedInUserState({
  //       ...userDetails,
  //       ...get(data, "getUser", {}),
  //     });
  //     setUserDetails({
  //       ...userDetails,
  //       ...get(data, "getUser", {}),
  //     });
  //     if (get(data, "getUser.onboarding", "") != "Completed") {
  //       history.push({
  //         pathname: `${ONBOARDING}`,
  //         state: { login: true },
  //       });
  //     }
  //   },
  // });

  // const [getUserCompany] = useLazyQuery(getLoggedInUserCompany, {
  //   ssr: false,
  //   nextFetchPolicy: FETCH_POLICY.cacheOnly,
  //   onCompleted: (data) => {
  //     setCompanyDetails(get(data, GETUSER_COMPANY, {}));
  //     setLoggedInUserState({
  //       ...userDetails,
  //       company: get(data, GETUSER_COMPANY, {}),
  //     });
  //     setUserDetails({
  //       ...userDetails,
  //       company: get(data, GETUSER_COMPANY, {}),
  //     });
  //   },
  // });
  useEffect(() => {
    setUserDetails(getLoggedInUserState);
  }, [getLoggedInUserState]);
  // const [metaDataDetailValues] = useLazyQuery(metaData, {
  //   onCompleted: (data) => {
  //     setMetaDataDetails(get(data, "listMetaData.items", []));
  //   },
  // });

  // const [getCountriesList] = useLazyQuery(listCountries, {
  //   onCompleted: (data) => {
  //     addCountries(data);
  //   },
  // });

  const companyId = get(Auth, "user.attributes.custom:companyId");

  useEffect(() => {
    if (get(userDetails, "id", "")) {
      metaDataDetailValues();
      getCountriesList();
    }
  }, [get(userDetails, "id", "")]);
  const metaDataValues = useRecoilValue(metaDataDetails);

  useEffect(() => {
    const reviewCycle = {
      listMetaData: {
        items: get(metaDataValues, "reviewcycle"),
      },
    };
    const options = {
      listMetaData: {
        items: get(metaDataValues, "options"),
      },
      metaData,
    };
    addOptionsForReviewCycle(reviewCycle);
    addOptionsForCompanySetting(options);
  }, [metaDataValues]);
  useEffect(() => {
    _setInstructions();
  }, [getMetaDataDetails]);

  const variables = {
    id: userId,
    companyId,
  };

  useEffect(() => {
    if (userId && companyId && !get(userDetails, "id", "")) {
      getUserDetail({
        variables,
      });
      getUserCompany({ variables });
    }
  }, [userId, companyId]);
  const pathname = history.location.pathname;

  // menubar close on url change
  useEffect(() => {
    setDrawerOpen(false);
  }, [pathname]);

  const [selectedIndex, setSelectedIndex] = useState();
  const [subSelectedIndex, setSubSelectedIndex] = useState();
  const selectedSubIndexValue = () => {
    if (pathname.includes(SUCCESS_STORIES)) {
      return 0;
    } else if (pathname.includes(PERFORMANCE_REVIEW)) {
      return 1;
    } else if (pathname.includes(DEPARTMENTS)) {
      return 2;
    } else if (pathname.includes(COACHING)) {
      return 3;
    } else if (pathname.includes(EXECUTIVE)) {
      return 4;
    }
  };

  const selectedIndexValue = () => {
    if (pathname.includes("/user")) {
      return 1;
    } else if (pathname.includes(TARGET)) {
      return 2;
    } else if (pathname.includes(CHECKIN)) {
      return 3;
    } else if (pathname.includes(COMPANY)) {
      return 4;
    } else if (pathname.includes(VISION)) {
      return 5;
    } else if (pathname.includes(REPORTS)) {
      return 6;
    } else if (pathname.includes(PROFILE)) {
      return LEFT_DRAW_INDEX;
    } else {
      return 0;
    }
  };
  useEffect(() => {
    setSelectedIndex(selectedIndexValue());
    setSubSelectedIndex(selectedSubIndexValue());
  }, [pathname]);
  const handleDrawerToggle = (value) => {
    setDrawerOpen(value);
  };

  //   for header items - notification, search, user setting
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const handleProfileMenuOpen = (event) => {
    if (!get(userDetails, "termsAndConditionsAccepted", false)) {
      event.preventDefault();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleLogout = () => {
    const variableDetails = {
      companyId,
      userId,
    };
    logOutUserDetail({ variables: variableDetails }).then(() => {
      Auth.signOut().then(() => {
        localStorage.removeItem("tenantId");
        window.location.href = "/";
      });
      handleMenuClose();
    });
  };
  const handleProfile = () => {
    history.push(`${USER_PROFILE}/${userId}`);
    handleMenuClose();
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  return (
    <Fragment>
      <CssBaseline />
      <Header
        isDrawerOpen={isDrawerOpen}
        menuId={menuId}
        handleMobileMenuOpen={handleMobileMenuOpen}
        handleProfileMenuOpen={handleProfileMenuOpen}
        mobileMenuId={mobileMenuId}
        userDetails={userDetails}
        isCompanySetupCompleted={props.isCompanySetupCompleted}
        refreshHeader={refreshHeader}
      />
      <MobileMenu
        mobileMoreAnchorEl={mobileMoreAnchorEl}
        handleMobileMenuClose={handleMobileMenuClose}
        handleProfileMenuOpen={handleProfileMenuOpen}
        handleLogout={handleLogout}
        logOutLoading={logOutLoading}
        handleProfile={handleProfile}
        menuId={menuId}
        mobileMenuId={mobileMenuId}
        userDetails={userDetails}
        isCompanySetupCompleted={props.isCompanySetupCompleted}
      />
      <ProfileMenu
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
        handleLogout={handleLogout}
        logOutLoading={logOutLoading}
        handleProfile={handleProfile}
        menuId={menuId}
        isCompanySetupCompleted={props.isCompanySetupCompleted}
      />
      {props.isCompanySetupCompleted && (
        <LeftDrawer
          handleDrawerToggle={handleDrawerToggle}
          isDrawerOpen={isDrawerOpen}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          subSelectedIndex={subSelectedIndex}
          setSubSelectedIndex={setSubSelectedIndex}
          getCompanyDetails={getCompanyDetails}
          refreshHeader={refreshHeader}
          setRefreshHeader={setRefreshHeader}
        />
      )}
      {showAnimation && (
        <TargetCompletion
          open={showAnimation}
          setOpen={setShowAnimation}
          message={"Target completed successfully"}
        />
      )}
    </Fragment>
  );
};

export default Layout;
